export default defineNuxtRouteMiddleware((to, from) => {
  useCartRedirect().savePath(from.fullPath);
});
